class validation {
    static NameRegx=/^[A-Za-z\s]+$/;
    static MobileRegx=/^[0]{1}?\d{10}$/;
    //static EmailRegx=/^[\w-]+@([\w-])+[\w-]{2,4}$/g;
    static EmailRegx=/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;    
    static YoutubeRegx = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
}

export default validation;